import { useMemo } from 'react';
import {
  useLocation, useNavigate 
} from 'react-router-dom';
import { RefreshCw } from 'lucide-react';
import { Button } from '@/components/ui/button';
import {
  TABS, type TabId 
} from './procurement-constants';
import { RequestsView } from './requests-view';
import { SourcingView } from './sourcing-view';
import { BidsView } from './bids-view';
import { OrdersView } from './orders-view';

export function ProcurementPage() {
  const location = useLocation();
  const navigate = useNavigate();

  const activeTab = useMemo((): TabId => {
    if (location.pathname.includes('/requests')) return 'requests';
    if (location.pathname.includes('/sourcing')) return 'sourcing';
    if (location.pathname.includes('/bids')) return 'bids';
    if (location.pathname.includes('/orders')) return 'orders';
    return 'requests';
  }, [location.pathname]);

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-2xl font-semibold">Procurement</h1>
          <p className="text-muted-foreground">Manage supplier orders and deliveries</p>
        </div>
        <Button variant="outline" size="sm" onClick={() => window.location.reload()}>
          <RefreshCw className="mr-2 h-4 w-4" /> Refresh
        </Button>
      </div>

      <div className="border-b">
        <nav className="flex gap-4">
          {TABS.map((tab) => {
            const Icon = tab.icon;
            const isActive = activeTab === tab.id;
            return (
              <button
                key={tab.id}
                type="button"
                onClick={() => navigate(tab.href)}
                className={`flex items-center gap-2 border-b-2 px-1 py-3 text-sm font-medium transition-colors ${
                  isActive
                    ? 'border-primary text-primary'
                    : 'border-transparent text-muted-foreground hover:border-muted-foreground/50 hover:text-foreground'
                }`}
              >
                <Icon className="h-4 w-4" />
                {tab.label}
              </button>
            );
          })}
        </nav>
      </div>

      {activeTab === 'requests' && <RequestsView />}
      {activeTab === 'sourcing' && <SourcingView />}
      {activeTab === 'bids' && <BidsView />}
      {activeTab === 'orders' && <OrdersView />}
    </div>
  );
}
